import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function updateDeal(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = `${urls.updateDeal}${data.id}`
  const storeId = await self.servicesVars.getStoreId()

  const body = {
    id: data.id,
    endDate: data.endDate,
    storeId: storeId,
    discount: data.discount,
    productId: data.productId,
    productData: data.productData,
    inPercent: true,
  }

  const response = await Network.sendPutRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { updateDeal }
